import "./style.css";
import Modal from "../";
import Button from "components/Buttons";
import { useNavigate } from "react-router-dom";
import { useModalStore, Modal as ModalKey } from "stores/modal/useModalStore";
import { useHorseStore } from "stores/horse/useHorseStore";

const CongratsModal = () => {
  const navigate = useNavigate();
  const close = useModalStore((s) => s.close);
  const current = useModalStore((s) => s.current);
  const isOpen = current === ModalKey.Congratulation;
  const horseName = useHorseStore(state => state.horseName);

  return (
    <Modal
      isCloseIcon
      overlayZIndex={1000}
      contentZIndex={1001}
      modalIsOpen={isOpen}
      closeModal={close}
      className={`relative z-10 flex flex-col !p-10`}
    >
      {{
        content: (
          <div className="flex flex-col justify-center items-center gap-4 mt-2">
            <h3 className="congrats_title">Congratulations!</h3>
            <p className="congrats_description">
              {`We added "${horseName}" to your profile, please click below.`}
            </p>
            <Button
              onClick={() => {
                navigate("/event");
                close();
              }}
              className={`btn-schedule`}
              primary
              whiteOutline
            >
              Schedule Scan
            </Button>
          </div>
        ),
      }}
    </Modal>
  );
};

export default CongratsModal;
